import { ProjectInfo } from "../User";
import ProjectCard from "./ProjectCard";

const Projects = () => {
    return (
        <div 
            className="px-16 mx-20 md-mx:px-6 sm-mx:px-4 xs-mx:px-2 lg-mx:mx-0 my-20 mb-32 font-mono" 
            id="Projects"
        >
            {/* Section Header */}
            <div className="text-center mb-16">
                <h1 className="text-4xl sm-mx:text-3xl xs-mx:text-2xl font-bold text-white mb-4">
                    <span className="text-primaryColor">03.&nbsp;</span>Projects
                </h1>
                <div className="w-24 h-1 bg-primaryColor mx-auto rounded-full"></div>
                <p className="text-textColor text-lg md-mx:text-base sm-mx:text-sm mt-4 max-w-2xl mx-auto">
                    Here are some of my featured projects that showcase my skills and experience
                </p>
            </div>
            
            {/* Projects Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md-mx:gap-6 sm-mx:gap-4">
                {ProjectInfo.map((project: any, index: number) => (
                    <div key={index} data-aos="fade-up" data-aos-duration="800" data-aos-delay={index * 100}>
                        <ProjectCard 
                            title={project.title} 
                            desc={project.desc} 
                            image={project.image} 
                            live={project.live} 
                            link={project.link} 
                            github={project.github} 
                            technologies={project.technologies} 
                        />
                    </div>
                ))}
            </div>
            
            {/* Call to Action */}
            <div className="text-center mt-16">
                <p className="text-textColor text-lg md-mx:text-base mb-6">
                    Want to see more of my work?
                </p>
                <a
                    href="https://github.com/PinakGupta"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primaryColor text-primaryColor hover:bg-primaryColor hover:text-bgColor transition-all duration-300 rounded-lg font-medium hover:scale-105"
                >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                    </svg>
                    View More on GitHub
                </a>
            </div>
        </div>
    );
};

export default Projects;